(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Dawn 16: the account `open` event is composed but does not bubble, so listen during capture,
  // and anchor the dialog to the bottom of the account button itself.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  /* Fullscreen mobile menu: keep the overlay top bar context-aware. At root it
     shows the centred logo; inside a submenu it swaps the logo for the submenu
     title and reveals a back control (top-left, same row as the close X). */
  (function () {
    function initFullscreenNav() {
      var drawer = document.querySelector('header-drawer[data-mobile-nav="fullscreen"] .menu-drawer');
      if (!drawer || drawer.dataset.overlayNavInit) return;
      var bar = drawer.querySelector('.th-mobile-menu__overlay-bar');
      if (!bar) return;
      drawer.dataset.overlayNavInit = '1';

      var titleEl = bar.querySelector('.th-mobile-menu__overlay-title');
      var backBtn = bar.querySelector('.th-mobile-menu__overlay-back');
      var closeBtn = bar.querySelector('.th-mobile-menu__overlay-close');

      var rootContainer = drawer.closest('details');
      var rootSummary = rootContainer && rootContainer.querySelector('summary');
      var headerDrawer = drawer.closest('header-drawer');
      // The drilldown title/back machinery assumes the slide model (one submenu
      // covers the root). Accordion expands in place with several open at once, so
      // the overlay just keeps the centred logo there.
      var isSlide = !headerDrawer || headerDrawer.getAttribute('data-submenu-style') !== 'accordion';

      function deepestOpenSubmenu() {
        var open = drawer.querySelectorAll('details[open]');
        return open.length ? open[open.length - 1] : null; // document order → last is deepest
      }

      function applyState(open) {
        if (open) {
          var summary = open.querySelector('summary');
          if (titleEl) titleEl.textContent = summary ? summary.textContent.trim() : '';
          drawer.classList.add('th-has-open-submenu');
        } else {
          drawer.classList.remove('th-has-open-submenu');
          if (titleEl) titleEl.textContent = '';
        }
      }

      function sync() {
        applyState(deepestOpenSubmenu());
      }

      if (closeBtn && rootSummary) {
        // Dawn auto-binds every drawer <button> to onCloseButtonClick, which only
        // runs closeSubmenu — that does NOT drop the body `overflow-hidden-*` scroll
        // lock, so the page stays unscrollable after closing. Intercept in the
        // capture phase and close via the summary instead, routing through
        // closeMenuDrawer, which releases the lock.
        closeBtn.addEventListener(
          'click',
          function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            rootSummary.click();
          },
          true
        );
      }

      // Cart icon in the overlay bar: open the cart drawer instead of leaving for /cart (the link
      // stays the fallback when there's no drawer). The cart slides in over the open menu, and the
      // menu closes unseen behind it once the cart covers the screen, so the page never flashes between.
      var cartLink = bar.querySelector('.th-mobile-menu__overlay-cart');
      if (cartLink && rootSummary) {
        cartLink.addEventListener('click', function (event) {
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
          event.preventDefault();
          document.body.classList.add('th-menu-handoff');
          cartDrawer.open(document.querySelector('#cart-icon-bubble') || cartLink);
          setTimeout(function () {
            var menu = rootSummary.closest('header-drawer');
            document.body.classList.add('th-menu-instant');
            if (menu && typeof menu.closeMenuDrawer === 'function') {
              // HeaderDrawer only closes with an element to hand focus back to; the cart takes it below
              menu.closeMenuDrawer(event, rootSummary);
              rootSummary.setAttribute('aria-expanded', 'false');
            } else {
              rootSummary.click();
            }
            // closing the menu released the focus trap: hand it back to the cart
            var trapOn = cartDrawer.classList.contains('is-empty')
              ? cartDrawer.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            if (trapOn && typeof trapFocus === 'function') trapFocus(trapOn, cartDrawer.querySelector('.drawer__inner'));
            setTimeout(function () {
              document.body.classList.remove('th-menu-handoff', 'th-menu-instant');
            }, 450);
          }, 420);
        });
      }

      if (isSlide && backBtn) {
        // Capture phase so this runs before Dawn's bubble handler, which would
        // otherwise close the whole drawer instead of stepping back one level.
        backBtn.addEventListener(
          'click',
          function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            var open = deepestOpenSubmenu();
            if (!open) return;
            var back = open.querySelector('.menu-drawer__close-button');
            // Update the bar instantly to the level we return to. Dawn defers the
            // `open` removal by the 400ms slide-out, so waiting for the observer
            // would leave the logo swap lagging behind — apply it now.
            var parent = open.parentElement && open.parentElement.closest('details');
            applyState(parent && parent !== rootContainer ? parent : null);
            if (back) back.click();
          },
          true
        );
      }

      if (isSlide) {
        new MutationObserver(sync).observe(drawer, {
          attributes: true,
          attributeFilter: ['open'],
          subtree: true,
        });
        sync();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFullscreenNav);
    } else {
      initFullscreenNav();
    }
    // Section re-renders in the theme editor swap in fresh drawer markup without
    // the capture listeners; re-init (the overlayNavInit guard makes it safe).
    document.addEventListener('shopify:section:load', initFullscreenNav);
  })();

  } catch(e) { console.error(e); }
})();
})();
